import { Component } from '@theme/component';

/** @extends {Component} */
class CfNewsletterForm extends Component {
  /** @param {Event} event */
  async handleSubmit(event) {
    event.preventDefault();

    const email = this.refs.emailInput?.value.trim();
    if (!email) return;

    const listId    = this.dataset.listId    || 'MQLkqr';
    const companyId = this.dataset.companyId || 'JXsSet';

    if (this.refs.submitButton)  this.refs.submitButton.disabled = true;
    if (this.refs.errorMessage)  this.refs.errorMessage.hidden   = true;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-04-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.status !== 202) {
        const body = await response.text().catch(() => '');
        throw new Error(`Klaviyo ${response.status}: ${body}`);
      }

      if (this.refs.emailInput)     this.refs.emailInput.value       = '';
      if (this.refs.successMessage) this.refs.successMessage.hidden  = false;
      if (this.refs.consentDefault) this.refs.consentDefault.hidden  = true;
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      if (this.refs.errorMessage) this.refs.errorMessage.hidden = false;
    } finally {
      if (this.refs.submitButton) this.refs.submitButton.disabled = false;
    }
  }
}

customElements.define('cf-newsletter-form', CfNewsletterForm);
